var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 304,
    viewBox: "0 0 380 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.074 143.463V121.589C173.074 115.848 177.729 111.193 183.47 111.193H222.516",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.771 78.1006H162.207",
    stroke: "black",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.029 162.328C258.788 161.599 259.623 159.583 258.895 157.824C258.166 156.065 256.15 155.23 254.391 155.958C252.632 156.687 251.797 158.703 252.526 160.462C253.254 162.221 255.271 163.056 257.029 162.328Z",
    fill: "#26BE43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.335 80.2494C206.311 82.7408 204.759 85.0941 202.383 85.943C200.006 86.7919 197.186 86.0812 195.536 84.0636C193.886 82.0459 193.767 79.2781 195.054 77.1262C196.341 74.9743 198.947 73.778 201.423 74.2834C204.262 74.8638 206.307 77.3513 206.335 80.2455C206.347 81.5168 208.321 81.5168 208.309 80.2455C208.277 76.8498 206.149 73.8451 202.967 72.6685C199.784 71.4918 196.195 72.5342 194.099 75.0809C192.002 77.6277 191.599 81.4931 193.384 84.415C195.169 87.3368 198.568 88.7661 201.885 88.1225C205.608 87.4 208.274 83.9846 208.313 80.2415C208.325 78.9701 206.351 78.9701 206.339 80.2415L206.335 80.2494Z",
    fill: "#26BE43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.584 83.433C203.343 82.7045 204.178 80.6881 203.449 78.9293C202.721 77.1705 200.704 76.3353 198.946 77.0638C197.187 77.7924 196.352 79.8087 197.08 81.5675C197.809 83.3263 199.825 84.1615 201.584 83.433Z",
    fill: "#26BE43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.786 147.175C178.837 145.124 178.837 141.799 176.786 139.748C174.735 137.698 171.41 137.698 169.359 139.748C167.308 141.799 167.308 145.124 169.359 147.175C171.41 149.226 174.735 149.226 176.786 147.175Z",
    fill: "#071A24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.477 111.889C225.863 110.251 224.849 108.609 223.21 108.222C221.572 107.836 219.93 108.85 219.543 110.489C219.157 112.127 220.171 113.769 221.81 114.156C223.448 114.542 225.09 113.528 225.477 111.889Z",
    fill: "#071A24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.757 12.0565V84.2808H238.392V122.691H128.603V12.0565H311.757Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.603 2H100.601V12.0487H128.603V2Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.757 34.4242H128.603",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.757 56.3102H128.603",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.603 100.078H162.14H199.259H238.392",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.518 84.2808V78.1963V56.3103V34.4242V12.0565",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.392 84.2808V78.1963V56.3103V34.4242V12.0565",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.262 12.0565V34.4242V56.3103",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.14 122.691V100.078V78.1963V56.3103V34.4242V12.0565",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M238.392 122.691V84.2808H311.757",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M180.402 47.7935C182.493 47.7935 184.188 46.0982 184.188 44.007C184.188 41.9157 182.493 40.2205 180.402 40.2205C178.311 40.2205 176.615 41.9157 176.615 44.007C176.615 46.0982 178.311 47.7935 180.402 47.7935Z",
    fill: "#26BE43"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.518 39.9125C279.549 39.9125 282.006 37.4553 282.006 34.4242C282.006 31.3931 279.549 28.9359 276.518 28.9359C273.487 28.9359 271.03 31.3931 271.03 34.4242C271.03 37.4553 273.487 39.9125 276.518 39.9125Z",
    fill: "#26BE43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M317.538 162.187H269.245V172.835H317.538V162.187Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M347.068 162.187H329.861V172.835H347.068V162.187Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M255.71 152.087V133.794H378.154V184.491H255.71V166.202",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.71 150.527H378.154",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.048 150.527V184.491",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M300.579 150.527V184.491",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M338.512 150.527V184.491",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M311.757 12.0565C306.356 24.4111 289.816 32.7027 276.518 34.4282C260.424 36.5169 246.538 66.9236 220.182 65.7667C204.689 65.0836 197.151 43.9873 179.407 43.9873C153.422 43.9873 128.607 78.2002 128.607 78.2002",
    stroke: "#26BE43",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M265.253 145.323C267.089 145.323 268.578 143.835 268.578 141.999C268.578 140.163 267.089 138.674 265.253 138.674C263.417 138.674 261.928 140.163 261.928 141.999C261.928 143.835 263.417 145.323 265.253 145.323Z",
    fill: "#071A24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M275.614 145.323C277.45 145.323 278.938 143.835 278.938 141.999C278.938 140.163 277.45 138.674 275.614 138.674C273.778 138.674 272.289 140.163 272.289 141.999C272.289 143.835 273.778 145.323 275.614 145.323Z",
    fill: "#071A24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200.266 80.2494V148.683C200.266 154.46 204.949 159.142 210.726 159.142H255.71",
    stroke: "#26BE43",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M261.494 159.143C261.47 161.5 260.006 163.754 257.751 164.56C255.497 165.365 252.827 164.718 251.232 162.807C249.637 160.896 249.523 158.223 250.751 156.169C251.979 154.116 254.446 152.983 256.796 153.461C259.512 154.01 261.467 156.379 261.494 159.147C261.506 160.418 263.48 160.418 263.468 159.147C263.437 155.877 261.395 152.987 258.335 151.846C255.275 150.705 251.773 151.712 249.752 154.183C247.73 156.655 247.355 160.359 249.076 163.17C250.798 165.981 254.063 167.355 257.254 166.743C260.851 166.052 263.429 162.759 263.464 159.143C263.476 157.871 261.502 157.871 261.49 159.143H261.494Z",
    fill: "#26BE43"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M285.658 145.323C287.495 145.323 288.983 143.835 288.983 141.999C288.983 140.163 287.495 138.674 285.658 138.674C283.822 138.674 282.334 140.163 282.334 141.999C282.334 143.835 283.822 145.323 285.658 145.323Z",
    fill: "#071A24"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2936 169.472C26.2936 169.472 26.3337 180.284 22.8754 180.515C19.417 180.747 21.0972 173.113 21.0972 173.113C21.0972 173.113 13.1376 183.666 9.8754 182.824C6.60869 181.982 10.379 177.708 10.379 177.708C10.379 177.708 6.20314 182.316 3.76983 180.404C1.33651 178.492 6.21205 174.86 6.21205 174.86C6.21205 174.86 2.60665 177.632 0.739322 175.751C-1.128 173.871 4.02831 171.246 4.02831 171.246C4.02831 171.246 1.11813 172.649 0.0530017 170.515C-1.01659 168.376 14.4568 159.511 14.4568 159.511L26.2981 169.472H26.2936Z",
    fill: "#071A24"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M173.42 93.1031C173.42 93.1031 174.222 82.7192 175.194 74.1714C175.916 67.8029 176.21 62.3881 178.282 62.192C181.295 61.9067 180.457 76.618 180.457 76.618C180.457 76.618 180.216 72.5135 183.305 72.4422C186.398 72.3664 185.48 76.1635 185.48 76.1635C185.48 76.1635 185.6 73.4004 188.238 73.6633C190.872 73.9263 189.468 77.5629 189.468 77.5629C189.468 77.5629 190.435 75.4281 192.637 76.3462C195.645 77.5985 188.893 93.2457 188.893 93.2457L173.42 93.1031Z",
    fill: "#071A24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1955 287.907L43.6432 289.694L45.3635 295.318L25.2775 302.729L6.23877 302.698L23.1873 296.784L39.1955 287.907Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M136.853 102.52C134.113 104.615 130.351 105.212 126.951 103.755C123.221 102.159 120.979 98.5358 120.961 94.7209C123.029 96.5437 125.707 98.3531 129.166 99.9441C131.907 101.201 134.482 102.021 136.853 102.52Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M139.06 100.176C139.372 100.492 139.746 100.755 140.174 100.938C141.956 101.7 144.02 100.876 144.782 99.0929C145.544 97.3102 144.719 95.2468 142.937 94.4847C142.206 94.1728 141.43 94.1238 140.717 94.302",
    fill: "#071A24"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.06 100.176C139.372 100.492 139.746 100.755 140.174 100.938C141.956 101.7 144.02 100.876 144.782 99.0929C145.544 97.3102 144.719 95.2468 142.937 94.4847C142.206 94.1728 141.43 94.1238 140.717 94.302",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.695 94.1816C119.259 94.2618 118.804 94.2618 118.345 94.1682C116.447 93.7716 115.23 91.9087 115.626 90.0146C116.023 88.1206 117.886 86.8995 119.78 87.2961C120.556 87.4565 121.22 87.8665 121.705 88.4192",
    fill: "#071A24"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.695 94.1816C119.259 94.2618 118.804 94.2618 118.345 94.1682C116.447 93.7716 115.23 91.9087 115.626 90.0146C116.023 88.1206 117.886 86.8995 119.78 87.2961C120.556 87.4565 121.22 87.8665 121.705 88.4192",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.476 137.848C148.659 140.673 143.378 142.991 136.822 144.827C140.575 157.782 134.821 173.755 121.482 184.206C104.841 197.246 82.683 196.742 71.9871 183.096C68.3282 178.421 66.4832 172.81 66.3183 166.923C66.3005 166.446 66.296 165.969 66.3049 165.492C66.3896 160.563 67.6196 155.491 69.9148 150.652C62.7664 151.079 56.2196 151.98 50.016 154.11C49.8778 154.654 49.753 155.197 49.6371 155.741C49.4633 156.543 49.3118 157.354 49.1737 158.161C48.0595 164.864 48.2556 171.611 49.86 177.984C50.3903 180.105 51.0766 182.182 51.9189 184.21C53.3807 187.744 55.3283 191.113 57.7749 194.228C74.4472 215.518 107.823 217.225 132.316 198.039C152.189 182.467 160.112 157.925 153.476 137.848ZM84.8133 133.266C91.0035 128.926 97.8311 126.372 104.485 125.588C106.285 125.374 108.063 125.289 109.819 125.334C115.671 125.476 121.202 127.036 125.81 130.022C134.656 128.293 140.401 125.944 145.138 123.132C144.652 122.57 144.153 122.022 143.641 121.487C138.979 116.625 133.333 113.029 127.111 110.716C127.049 110.689 126.986 110.671 126.928 110.649C109.971 104.419 88.8376 107.708 71.9336 120.944C66.7372 125.013 62.3608 129.692 58.8534 134.746C67.1205 133.565 75.5524 133.422 84.1582 133.275C84.3765 133.271 84.5949 133.266 84.8133 133.266Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.42 203.31L95.0017 203.288L94.9445 233.098L106.362 233.12L106.42 203.31Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.058 231.906L98.2626 231.897L98.1431 294.142L102.938 294.152L103.058 231.906Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0737 301.999H137.108L103.785 293.83H98.179L97.0737 301.999Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2063 287.905L43.6553 289.695L73.6007 215.241L69.1517 213.451L39.2063 287.905Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.933 98.5581C139.238 100.18 138.164 101.522 136.853 102.52C134.482 102.021 131.907 101.201 129.166 99.9441C125.707 98.3531 123.029 96.5437 120.961 94.7209C120.952 93.4062 121.211 92.0648 121.763 90.7768C122.053 90.0905 122.414 89.4577 122.833 88.8738C125.476 85.206 130.405 83.722 134.736 85.5759C138.293 87.1001 140.499 90.4604 140.713 94.0792C140.811 95.5632 140.557 97.0963 139.933 98.5581Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8537 134.746C54.6332 140.802 51.6651 147.394 50.0162 154.11C42.1859 156.793 34.9082 161.441 27.6528 169.565L15.0183 158.29C29.021 142.603 43.6432 136.916 58.8537 134.746Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M132.263 135.891C134.385 138.596 135.895 141.618 136.822 144.827C127.41 147.465 115.373 149.11 98.3438 149.849C93.5039 150.059 88.8958 150.135 84.4436 150.21C79.3096 150.295 74.4875 150.38 69.915 150.652C70.3741 149.684 70.8732 148.726 71.4169 147.781C73.106 144.831 75.2051 142.01 77.6829 139.394C79.2294 137.763 80.9274 136.221 82.7679 134.777C83.4409 134.251 84.1228 133.743 84.8135 133.266C88.9537 133.195 93.2232 133.119 97.6129 132.928C109.699 132.402 118.746 131.412 125.81 130.022C126.006 130.151 126.202 130.28 126.398 130.414C126.951 130.784 127.486 131.181 128.003 131.595C129.567 132.838 130.998 134.273 132.263 135.891Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M190.36 93.2457C186.353 104.628 178.265 119.66 162.007 132.058C159.217 134.184 156.436 136.114 153.477 137.848C153.071 136.609 152.603 135.383 152.082 134.18C150.647 130.864 148.784 127.695 146.475 124.754C146.039 124.201 145.593 123.658 145.138 123.132C147.5 121.728 149.617 120.208 151.739 118.591C160.688 111.767 167.52 103.251 172.097 93.2457H190.36Z",
    fill: "white",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report.91b5ab81a0fd0922bebc4763bacb75f2.svg";